
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import Stats from '../../components/feature/Stats';
import Features from '../../components/feature/Features';
import Scenarios from '../../components/feature/Scenarios';
import Integration from '../../components/feature/Integration';
import Security from '../../components/feature/Security';
import FAQ from '../../components/feature/FAQ';
import Partners from '../../components/feature/Partners';
import Contact from '../../components/feature/Contact';
import Footer from '../../components/feature/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Features />
        <Scenarios />
        <Integration />
        <Security />
        <FAQ />
        <Partners />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
